export const APP_STATE_STORAGE_KEY = 'app-state';
export const APP_ROUTE_STORAGE_KEY = 'app-route';

export interface RawStorageItems {
  state: string | null;
  route: string | null;
}
